// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.
export const environment = {
  production: false,
  environment: 'local',
  baseUrl: process.env.VITE_BASE_URL,
  bearerToken: process.env.VITE_BEARER_TOKEN,
  gaId: process.env.VITE_GA_ID
};
